module.exports = __webpack_public_path__ + "img/logo-x7trade-blue-white-nobg.80f0f225.svg";